import React, { useState, useEffect } from "react";
import { Table, Row, Col } from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { WizzMode } from "../../types";
import { useEntities } from "../../Wizzard";
import style from "./../../styles.module.scss";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

const Fundamentals = ({ mode, services, assetInfo }) => {
  const [, setReadonly] = useState(false);
  const [] = useState({ open: false });
  const [] = useEntities({});
  const [financials, setFundamentals] = useState();

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
    {
      assetInfo.AssetSynonym &&
        services.iextradingFinancial(assetInfo.AssetSynonym).then((res) => setFundamentals(res.financials));
    }
  }, [mode, assetInfo]);

  return (
    <Table>
      {financials ? (
        <div>
          {financials.map((financial) => {
            return [
              <div>
                {financial.reportDate && (
                  <Row className={style.styleDetails}>
                    <Col>Report Date:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedDate value={financial.reportDate} />
                    </Col>
                  </Row>
                )}

                {financial.cashChange && (
                  <Row className={style.styleDetails}>
                    <Col>Cash Change:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.cashChange} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.cashFlow && (
                  <Row className={style.styleDetails}>
                    <Col>Cash Flow</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.cashFlow} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.costOfRevenue && (
                  <Row className={style.styleDetails}>
                    <Col>Cost of revenue:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.costOfRevenue} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.currentAsset && (
                  <Row className={style.styleDetails}>
                    <Col>Current Assets:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.currentAsset} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.currentCash && (
                  <Row className={style.styleDetails}>
                    <Col>Current Cash:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.currentCash} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.currentDebt && (
                  <Row className={style.styleDetails}>
                    <Col>Current Debt:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.currentDebt} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.grossProfit && (
                  <Row className={style.styleDetails}>
                    <Col>Gross Profit:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.grossProfit} dataTypeDecimalName="currencys" />
                    </Col>
                  </Row>
                )}

                {financial.netIncome && (
                  <Row className={style.styleDetails}>
                    <Col>Net Income:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.netIncome} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.operatingExpense && (
                  <Row className={style.styleDetails}>
                    <Col>Operating Expense:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.operatingExpense} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.operatingGainsLosses && (
                  <Row className={style.styleDetails}>
                    <Col>Operating gains losses:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber
                        value={financial.operatingGainsLosses}
                        dataTypeDecimalName="currency"
                      />
                    </Col>
                  </Row>
                )}

                {financial.operatingIncome && (
                  <Row className={style.styleDetails}>
                    <Col> Operation income:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.operatingIncome} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.operatingRevenue && (
                  <Row className={style.styleDetails}>
                    <Col>Operating revenue:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.operatingRevenue} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.researchAndDevelopment && (
                  <Row className={style.styleDetails}>
                    <Col> Research and development:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber
                        value={financial.researchAndDevelopment}
                        dataTypeDecimalName="currency"
                      />
                    </Col>
                  </Row>
                )}

                {financial.shareholderEquity && (
                  <Row className={style.styleDetails}>
                    <Col>Share holder equity:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.shareholderEquity} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.totalAssets && (
                  <Row className={style.styleDetails}>
                    <Col>Total assets:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.totalAssets} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.totalCash && (
                  <Row className={style.styleDetails}>
                    <Col>Total cash:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.totalCash} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.totalDebt && (
                  <Row className={style.styleDetails}>
                    <Col>Total debt:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.totalDebt} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.totalLiabilities && (
                  <Row className={style.styleDetails}>
                    <Col>Total liabilities:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.totalLiabilities} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}

                {financial.totalRevenue && (
                  <Row className={style.styleDetails}>
                    <Col>Total revenue:</Col>
                    <Col style={{ textAlign: "right" }}>
                      <FormattedNumber value={financial.totalRevenue} dataTypeDecimalName="currency" />
                    </Col>
                  </Row>
                )}
              </div>,
            ];
          })}
          {Fundamentals.length == 0 && <EmptyOrLoading />}
        </div>
      ) : (
        <EmptyOrLoading loading={true} />
      )}
    </Table>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="4">
      {loading ? (
        <LoadingMessage text="Loading fundamentals" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No fundamentals
        </span>
      )}
    </td>
  </tr>
);

export default Fundamentals;
